import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../SponsorsPage';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import RodapeLP from '../Home/modules/RodapeLP';
import Whatsapp from '../../components/Whatsapp';
import { ContactIcons } from 'src/components/MenuOld';
import { getYear } from 'date-fns';
import { Link } from 'react-router-dom';

const FooterLayout: React.FC = ({ children }) => {
  return (<>
    <div style={{ background: 'none', position: 'relative', zIndex: 10000, display: 'block' }}>


      <div className='column max-1200 full-width' style={{ alignItems: 'flex-end', zIndex: 2, position: 'relative', gap: '15px', justifyContent: 'space-between', margin: '0px auto', padding: '10px 10px' }}>

        <Link to="/politica"> <p style={{ color: '#fff', fontSize: '14px', width: '100%', textAlign: 'right' }} >Política de cancelamento e reembolso.</p></Link>
        <Link to="/termos"> <p style={{ color: '#fff', fontSize: '14px', width: '100%', textAlign: 'right' }} >LGPD / Termos.</p></Link>

        <ContactIcons color="#fff" />
        <p style={{ color: '#fff', fontSize: '14px', width: '100%', textAlign: 'right' }} >1º Fórum Atacadista © 2025 - Todos os direitos reservados.</p>

      </div>
    </div>
  </>
  );
};

export default FooterLayout;
